// keys of MietpreisGemeinde
export const ROOM_SIZE_NAMES: Array<keyof MietpreisGemeinde> = [
  'Zi_1-1.5',
  'Zi_2–2.5',
  'Zi_3–3.5',
  'Zi_4–4.5',
  'Zi_5+',
]

export const ROOM_PRICE_NAMES = [
  '500',
  '1000',
  '1500',
  '2000',
  '2500',
  '3000',
  '4000',
  '> 4000',
]
export const COLOR_PALLETTE = ['#9e272f', 'lightgrey', '#296b8e'] as [
  string,
  string,
  string
]
